import React, { useCallback, useEffect, useState } from "react"

import { wownetApi } from "@shared/apis"
import { PartnerInfo } from "@shared/apis/wownet"
import {useAccount, useLayerPopupContext, useSchedule} from "@shared/contexts"

import BroadcastNoti from "./BroadcastNoti"
import JoinInfo from "./JoinInfo"
import Partner from "./Partner"
import {BroadCastShare} from "./BroadCastShare";
import {useIsMiniPlayerEnabled} from "../../contexts/miniPlayer";
import WownetCustomerCenter from "./WownetCustomerCenter";

const initialPartnerInfo = {
  isAlarmOn: false,
}

const QuickMenu = () => {
  const { schedule } = useSchedule()
  const {
    account: { viewer },
  } = useAccount()
  const [partnerInfo, setPartnerInfo] =
    useState<PartnerInfo>(initialPartnerInfo)
  const isMiniPlayerEnabled = useIsMiniPlayerEnabled()

  const {
    open,
    share: { handleShare },
  } = useLayerPopupContext()

  const streamerUsername = schedule?.user.username
  const username = viewer?.username
  const isAnonymous = viewer?.role === "ANONYMOUS"

  const getPartnerInfo = useCallback(() => {
    if (isAnonymous) return

    wownetApi.getPartnerInfo(streamerUsername!, username!).then(({ data }) =>
      setPartnerInfo({
        isAlarmOn: data.isAlarmOn === "true",
      }),
    )
  }, [isAnonymous, streamerUsername, username])

  useEffect(() => {
    if (!streamerUsername || !username) return

    getPartnerInfo()
  }, [streamerUsername, username, getPartnerInfo])



  if (isMiniPlayerEnabled)  {
    return null
  }

  return (
    <div className="quickMenuB">
      <Partner />
      <BroadcastNoti
        getPartnerInfo={getPartnerInfo}
        isAlarmOn={partnerInfo.isAlarmOn as boolean}
      />
      <JoinInfo />
      {schedule?.paymentInformation === "ALL" &&
        <BroadCastShare
          handleBroadcastShare={() => {
            handleShare({ title: "방송 공유하기", url: `https://${window.location.hostname}/${streamerUsername}/${schedule?.id}` })
            open("SHARE")
          }}
        />
      }
      <WownetCustomerCenter />
    </div>
  )
}

export default QuickMenu
